/**
 * Generated runtime TestId mirror for frontend/src/pages/SchemaPolicies.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SchemaPoliciesTestIds = {
  btnCreatePolicy: "btn-create-policy",
  colEnabled: "col-enabled",
  colLastReviewed: "col-last-reviewed",
  colName: "col-name",
  colSeverity: "col-severity",
  colType: "col-type",
  colViolations: "col-violations",
  schemaPoliciesList: "schema-policies-list",
  linkPolicy: (policy_id: string) => `link-policy-${policy_id}`,
  linkPolicyPrefix: () => "link-policy-" as TestIdPrefix,
  policyRow: (policy_id: string) => `policy-row-${policy_id}`,
  policyRowPrefix: () => "policy-row-" as TestIdPrefix,
  policyViolations: (policy_id: string) => `policy-violations-${policy_id}`,
  policyViolationsPrefix: () => "policy-violations-" as TestIdPrefix
} as const;
